<!--头部信息-->
<template>
  <div class="TopBar clearfix">
    <!-- right展开、left收起 -->
    <div class="switchIcon">
      <i
        :class="$store.state.isCollapse ? 'ico ico-menu-fold' : 'ico ico-menu-unfold'"
        @click="switchCollapse"></i>
    </div>
    <div class="HeadBarRight clearfix">
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
          {{$store.state.userInfo.user_name}}
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="map">
            <i class="el-icon-location-outline"></i>
            仪表盘
          </el-dropdown-item>
          <el-dropdown-item command="modifyPassword" divided>
            <i class="ico ico-my"></i>
            修改密码
          </el-dropdown-item>
          <el-dropdown-item command="loginSetting">
            <i class="ico ico-settings"></i>
            基本设置
          </el-dropdown-item>
          <el-dropdown-item command="loginOut" divided>
            <i class="ico ico-login"></i>
            退出登录
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div> 
  </div>
</template>

<script>
  import { updataBreadCrumb } from "../../../static/js/utility/utility.js"

  export default {
    name: 'TopBar',
    data() {
      return {
      }
    },
    mounted() {
    },
    methods: {
      // 点击下拉菜单list，点击执行相关操作
      handleCommand(command) {
        // console.log('command', command)
        if (command === 'map') {
          this.$router.push({
            path: '/Map'
          })
        } else if (command === 'loginOut') {
          // 退出登录,清空缓存数据,跳转登录页
          localStorage.clear()
          sessionStorage.clear()
          this.$router.push({
            path: '/'
          })
        } else if(command === 'loginSetting'){
          let navBarActive = [{function_tab: 'LoginSetting', function_name: '基本设置'}]
          // 更新面包屑内容
          updataBreadCrumb(2, navBarActive)
          // 基本设置
          this.$router.push({
            path: '/LoginSetting'
          })
        } else {
          let navBarActive = [{function_tab: 'ModifyPassword', function_name: '修改密码'}]
          // 更新面包屑内容
          updataBreadCrumb(2, navBarActive)
          // 修改密码
          this.$router.push({
            path: '/ModifyPassword'
          })
        }
      },
      // 切换侧边栏折叠状态
      switchCollapse: function () {
        this.$store.state.isCollapse = !(this.$store.state.isCollapse)
        this.$emit('ievent', this.$store.state.isCollapse)
      }
    },
    watch: {
      // 监听侧边导航栏是否折叠，控制侧边栏的宽度，并计算右边区域的宽度
      '$store.state.isCollapse': function (newVal) {
        // console.log('是否折叠', this.$store.state.isCollapse)
        // 判断是否是地图页面
        let isMap = this.$route.path.indexOf('/Map') === -1 ? false : true
        if (newVal) {
          // 地图页的侧边栏，折叠后宽度为0
          this.$store.state.navBarWidth = isMap ? 0 : 80
        } else {
          this.$store.state.navBarWidth = 256
        }
        this.$store.state.rightAreaWidth = document.documentElement.clientWidth - this.$store.state.navBarWidth
      }
    }
  }
</script>

<style lang="scss" scoped>
$TopBarHeight: 64px;
.TopBar {
  height: $TopBarHeight;
  line-height: $TopBarHeight;
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
  position: relative;
  z-index: 99;
  .switchIcon {
    float: left;
    height: $TopBarHeight;
    font-size: 20px;
    cursor: pointer;
    transition: all .3s,padding 0s;
    padding: 0 24px;
    i{
      font-size: 20px;
      line-height: $TopBarHeight;
    }
  }
  .HeadBarRight{
    float: right;
    height: $TopBarHeight;
    line-height: $TopBarHeight;
    overflow: hidden;
    span {
      display: block;
      float: left;
      font-size: 14px;
      color: #828282;
      margin: 0 12px;
    }
  }
}
// 下拉菜单
.el-dropdown-menu {
  padding: 6px 0;
  .el-dropdown-menu__item {
    line-height: 35px;
  }
  // .el-dropdown-menu__item:nth-child(2){
  //   border-bottom: 1px solid #ebeef5;
  // }
  .el-dropdown-menu__item--divided {
    // margin-top: 4px;
    // border-top: none;
  }
  .el-dropdown-menu__item--divided:before {
    // height: 0;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/Layout/TopBar.vue